import type { App, Plugin } from 'vue'

import { vLazyImgInstall } from './lazy-img'

const directives = [vLazyImgInstall] satisfies Plugin[]

const plugin = {
	install(app: App) {
		for (const directive of directives) {
			app.use(directive)
		}
	},
} satisfies Plugin

export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.vueApp.use(plugin)
})
